var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "m-filters" },
        [
          _c("single-select", {
            attrs: {
              items: _vm.categories,
              value: _vm.selectedCategory,
              placeholder: "Select category",
            },
            on: { select: _vm.changeCategory },
          }),
          _vm._v(" "),
          _c("single-select", {
            attrs: {
              items: _vm.subCategories,
              value: _vm.selectedSubCategory,
              placeholder: "Select sub-category",
            },
            on: { select: _vm.changeSubCategory },
          }),
          _vm._v(" "),
          _c("autocomplete", {
            attrs: {
              keywords: _vm.filters.keywords,
              placeholder: "Search keyword",
            },
            on: { select: _vm.changeKeywords },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "m-filters__buttons" },
            [
              _c("filter-button", {
                attrs: {
                  icon: "/assets/img/icons/favourite.svg",
                  text: "Favourites",
                  selected: _vm.filters.favourites,
                },
                on: { select: _vm.changeFavourites },
              }),
              _vm._v(" "),
              _c("filter-button", {
                attrs: {
                  icon: "/assets/img/icons/gallery.svg",
                  text: "Custom Image",
                  selected: _vm.filters.customImage,
                  disabled: !_vm.hasCustomImage,
                },
                on: { select: _vm.changeCustomImage },
              }),
              _vm._v(" "),
              _c("filter-button", {
                attrs: {
                  text: "Custom Text",
                  selected: _vm.filters.customText,
                  disabled: !_vm.hasCustomText,
                },
                on: { select: _vm.changeCustomText },
              }),
              _vm._v(" "),
              _vm.metaData.popupText
                ? _c(
                    "tooltip",
                    {
                      attrs: { text: "Info", open: _vm.showPopup },
                      on: { close: _vm.dismissPopup },
                    },
                    [
                      _c("h3", {
                        staticClass: "u-color-pink",
                        domProps: {
                          innerHTML: _vm._s(_vm.metaData.popupTitle),
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        domProps: { innerHTML: _vm._s(_vm.metaData.popupText) },
                      }),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("tag-list", {
        attrs: { tags: _vm.filters.tags },
        on: { remove: _vm.removeTag, clearAll: _vm.clearAllTags },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }